export default __webpack_public_path__ + "static/media/popover.a98b199f.less";